export default __webpack_public_path__ + "static/media/non-vegetarian.475387be.svg";